/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseGradingStatsReportData } from './genericApiResponseGradingStatsReportData';
import type { GenericApiResponseGradingStatsReportMessage } from './genericApiResponseGradingStatsReportMessage';
import type { GenericApiResponseGradingStatsReportPagination } from './genericApiResponseGradingStatsReportPagination';
import type { GenericApiResponseGradingStatsReportError } from './genericApiResponseGradingStatsReportError';

export interface GenericApiResponseGradingStatsReport {
  data?: GenericApiResponseGradingStatsReportData;
  message?: GenericApiResponseGradingStatsReportMessage;
  pagination?: GenericApiResponseGradingStatsReportPagination;
  error?: GenericApiResponseGradingStatsReportError;
  statusCode?: number;
}
